import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'show-yoyaku-createria-app',
  templateUrl: './show-yoyaku-createria.component.html',
  styleUrls: ['show-yoyaku-createria.component.css']
})

export class ShowYoyakuCreateriaComponent {
  @Input() selected: any[];
  @Input() DayOfTheWeek: any[];

  weeks:any = [];

  constructor(
    public commonService: CommonService,
    public activeModal: NgbActiveModal,
  ) { }

  ret: any = {
    status: "",
  }
  //起動時処理
  ngOnInit(): void {
    this.createWeeks();
  }
  createWeeks(): void{
    var ids = this.selected["yoyaku_day_week"].split(',');
    var tmp = [];
    for(let i=0; ids.length>i; i++){
      tmp = this.DayOfTheWeek.filter((item) => item.id == ids[i]);
      this.weeks.push(tmp[0]);
    }
  };
  OK(): void {
    this.ret.status = 'OK';
    this.activeModal.close(this.ret);
  }
}




// WEBPACK FOOTER //
// ./src/app/a2103-yoyaku-register/show-yoyaku-createria.component.ts